module.exports = __webpack_public_path__ + "media/newstyle/images/card-icon-1-9ba2b4e7cdef3f12bfba0f2f3fe3aad8.svg";